// API Client für FridgeBuddy Backend

const API_BASE = '/api';

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'API Fehler');
  return data;
}

export const api = {
  // Haushalt
  joinHousehold: (code, name) =>
    request('/household', { method: 'POST', body: JSON.stringify({ code, name }) }),

  // Items
  getItems: (householdCode, showConsumed = false) =>
    request(`/items?household=${encodeURIComponent(householdCode)}${showConsumed ? '&consumed=true' : ''}`),

  addItems: (householdCode, items) =>
    request('/items', { method: 'POST', body: JSON.stringify({ household_code: householdCode, items }) }),

  updateItem: (id, updates) =>
    request(`/items/${id}`, { method: 'PATCH', body: JSON.stringify(updates) }),

  deleteItem: (id) =>
    request(`/items/${id}`, { method: 'DELETE' }),

  // Beleg parsen
  parseReceipt: (text) =>
    request('/parse-receipt', { method: 'POST', body: JSON.stringify({ text }) }),
};
